import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'
import {
  IconThumbUp,
  IconMessageDots,
  IconShare,
  IconEye,
  IconBrandFacebook,
  IconArrowNarrowUp,
  IconBrandTwitter,
  IconArrowNarrowDown,
  IconBrandInstagram,
  IconBrandLinkedin,
  IconBrandGoogle,
} from '@tabler/icons-react'
import ReactApexChart from 'react-apexcharts'
import { VectorMap } from '@react-jvectormap/core';
import { worldMill } from '@react-jvectormap/world';

export default function BlogDashboard() {

  const chartData1 = {
    options: {
      stroke: {
        width: 0,
        curve: 'straight',
      },
      fill: {
        type: "solid",
      },
      colors: ['var(--chart-color1)'],
      dataLabels: {
        enabled: false
      },
      chart: {
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true
        },
      },
      grid: {
        show: false,
      },
      xaxis: {
        categories: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        tooltip: {
          enabled: false,
        },
        crosshairs: {
          position: 'front',
          stroke: {
            color: 'var(--danger)',
            dashArray: 0,
          },
        }
      },
      yaxis: {
        show: false,
        min: 0,
        max: 50,
        tickAmount: 1,
      },
      tooltip: {
        x: {
          show: false,
        },
        style: {
          fontFamily: 'var(--font-family)',
        },
      },
      markers: {
        size: 0,
        hover: {
          size: 0,
        }
      },
    },
    series: [
      {
        name: "",
        data: [0, 10, 30, 15, 12, 25, 5, 40, 45, 20, 30, 12, 25, 5, 40, 45, 20, 30, 5, 40, 45, 20, 30,]
      }
    ]
  };

  const chartData2 = {
    options: {
      stroke: {
        width: 0,
        curve: 'straight',
      },
      fill: {
        type: "solid",
      },
      colors: ['var(--chart-color2)'],
      dataLabels: {
        enabled: false
      },
      chart: {
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true
        },
      },
      grid: {
        show: false,
      },
      xaxis: {
        categories: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        tooltip: {
          enabled: false,
        },
        crosshairs: {
          position: 'front',
          stroke: {
            color: 'var(--danger)',
            dashArray: 0,
          },
        }
      },
      yaxis: {
        show: false,
        min: 0,
        max: 50,
        tickAmount: 1,
      },
      tooltip: {
        x: {
          show: false,
        },
        style: {
          fontFamily: 'var(--font-family)',
        },
      },
      markers: {
        size: 0,
        hover: {
          size: 0,
        }
      },
    },
    series: [
      {
        name: "",
        data: [40, 10, 30, 15, 12, 25, 5, 40, 45, 20, 30, 12, 25, 5, 40, 45, 20, 30, 5, 40, 45, 20, 30,]
      }
    ]
  };

  const chartData3 = {
    options: {
      stroke: {
        width: 2,
        curve: 'straight',
      },
      fill: {
        type: "solid",
      },
      colors: ['var(--chart-color3)'],
      dataLabels: {
        enabled: false
      },
      chart: {
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true
        },
      },
      grid: {
        show: false,
      },
      xaxis: {
        categories: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        tooltip: {
          enabled: false,
        },
        crosshairs: {
          position: 'front',
          stroke: {
            color: 'var(--danger)',
            dashArray: 0,
          },
        }
      },
      yaxis: {
        show: false,
        min: 0,
        max: 50,
        tickAmount: 1,
      },
      tooltip: {
        x: {
          show: false,
        },
        style: {
          fontFamily: 'var(--font-family)',
        },
      },
      markers: {
        size: 0,
        hover: {
          size: 0,
        }
      },
    },
    series: [
      {
        name: "",
        data: [0, 10, 30, 15, 12, 25, 5, 40, 45, 20, 30, 12, 25, 5, 40, 45, 20, 30, 5, 40, 45, 20, 30,]
      }
    ]
  };

  const chartData4 = {
    options: {
      stroke: {
        width: 0,
        curve: 'straight',
      },
      fill: {
        type: "solid",
      },
      colors: ['var(--chart-color4)'],
      dataLabels: {
        enabled: false
      },
      chart: {
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: true
        },
      },
      grid: {
        show: false,
      },
      xaxis: {
        categories: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        tooltip: {
          enabled: false,
        },
        crosshairs: {
          position: 'front',
          stroke: {
            color: 'var(--danger)',
            dashArray: 0,
          },
        }
      },
      yaxis: {
        show: false,
        min: 0,
        max: 50,
        tickAmount: 1,
      },
      tooltip: {
        x: {
          show: false,
        },
        style: {
          fontFamily: 'var(--font-family)',
        },
      },
      markers: {
        size: 0,
        hover: {
          size: 0,
        }
      },
    },
    series: [
      {
        name: "",
        data: [30, 10, 30, 15, 12, 25, 5, 40, 45, 20, 30, 12, 25, 5, 40, 45, 20, 30, 5, 40, 45, 20, 30,]
      }
    ]
  };

  const chartData = {
    series: [
      {
        name: 'Series A ',
        data: [90, 49, 90, 61, 100, 40, 75],
        color: 'var(--chart-color1)'
      },
      {
        name: 'Series B ',
        data: [100, 36, 100, 45, 77, 15, 100],
        color: 'var(--chart-color2)'
      },
      {
        name: 'Series C ',
        data: [50, 90, 55, 90, 22, 90, 25],
        color: 'var(--chart-color3)'
      },
      {
        name: 'Series D ',
        data: [20, 71, 20, 42, 5, 60, 0],
        color: 'var(--chart-color4)'
      }
    ],
    options: {
      stroke: {
        width: 1,
        curve: 'smooth',
      },
      dataLabels: {
        enabled: false
      },
      markers: {
        size: 2,
        strokeColors: ['var(--chart-color1)', 'var(--chart-color2)', 'var(--chart-color3)', 'var(--chart-color4)'],
        hover: {
          size: 2,
        }
      },
      chart: {
        toolbar: {
          show: false,
        },
      },
      grid: {
        borderColor: 'var(--border)',
      },
      xaxis: {
        categories: ["2012", "2013", "2014", "2015", "2016", "2017", "2018"],
        labels: {
          style: {
            fontFamily: 'var(--font-family)',
          },
        },
        tooltip: {
          enabled: false,
        },
      },
      yaxis: {
        min: 0,
        max: 100,
        tickAmount: 4,
        labels: {
          style: {
            fontFamily: 'var(--font-family)',
          },
        }
      },
      responsive: [{
        breakpoint: 767,
        options: {
          chart: {
            height: 'auto'
          }
        },
      }]
    },
  };

  const chartData5 = {
    series: [55, 30, 15],
    options: {
      labels: ['Desktop', 'Mobile', 'Tablet'],
      colors: ['var(--chart-color1)', 'var(--chart-color2)', 'var(--chart-color3)'],
      legend: {
        show: false,
      },
      plotOptions: {
        pie: {
          expandOnClick: true,
          donut: {
            labels: {
              show: true,
              name: {
                show: true,
              },
              value: {
                show: true,
              },
            }
          }
        }
      },
    },
  };

  const chartData6 = {
    series: [66],
    options: {
      plotOptions: {
        radialBar: {
          hollow: {
            size: '70%',
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              offsetY: 8,
              fontSize: "24px",
              color: 'var(--chart-color1)',
              show: true,
            }
          },
        },
      },
      fill: {
        colors: ['var(--chart-color1)'],
      },
      stroke: {
        lineCap: "round",
      },
    },
  };

  const chartData7 = {
    series: [26],
    options: {
      plotOptions: {
        radialBar: {
          hollow: {
            size: '60%',
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              offsetY: 8,
              fontSize: "24px",
              color: 'var(--chart-color2)',
              show: true,
            }
          },
        },
      },
      fill: {
        colors: ['var(--chart-color2)'],
      },
      stroke: {
        lineCap: "round",
      },
    },
  };

  const chartData8 = {
    series: [76],
    options: {
      plotOptions: {
        radialBar: {
          hollow: {
            size: '60%',
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              offsetY: 8,
              fontSize: "24px",
              color: 'var(--chart-color3)',
              show: true,
            }
          },
        },
      },
      fill: {
        colors: ['var(--chart-color3)'],
      },
      stroke: {
        lineCap: "round",
      },
    },
  };

  const chartData9 = {
    series: [50],
    options: {
      plotOptions: {
        radialBar: {
          hollow: {
            size: '60%',
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              offsetY: 8,
              fontSize: "24px",
              color: 'var(--chart-color4)',
              show: true,
            }
          },
        },
      },
      fill: {
        colors: ['var(--chart-color4)'],
      },
      stroke: {
        lineCap: "round",
      },
    },
  };

  return (
    <>
      <Breadcrumb title="Dashboard" path="Blog / Dashboard" />
      <div className='grid xl:grid-cols-4 md:grid-cols-2 xl:gap-30 gap-20 mb-30'>
        <div className='bg-bg-dark rounded-lg shadow-light'>
          <div className='md:p-20 p-15'>
            <div className='text-[16px]/[20px] font-medium mb-10 flex items-center gap-10'>
              <IconThumbUp className='w-[20px] h-[20px] stroke-[1.5]' />
              Likes
            </div>
            <div className=''>
              22,500
            </div>
          </div>
          <ReactApexChart options={chartData1.options} series={chartData1.series} type="area" height={60} width="100%" />
        </div>
        <div className='bg-bg-dark rounded-lg shadow-light'>
          <div className='md:p-20 p-15'>
            <div className='text-[16px]/[20px] font-medium mb-10 flex items-center gap-10'>
              <IconMessageDots className='w-[20px] h-[20px] stroke-[1.5]' />
              Comments
            </div>
            <div className=''>
              500
            </div>
          </div>
          <ReactApexChart options={chartData2.options} series={chartData2.series} type="bar" height={60} width="100%" />
        </div>
        <div className='bg-bg-dark rounded-lg shadow-light'>
          <div className='md:p-20 p-15'>
            <div className='text-[16px]/[20px] font-medium mb-10 flex items-center gap-10'>
              <IconShare className='w-[20px] h-[20px] stroke-[1.5]' />
              Share
            </div>
            <div className=''>
              2,215
            </div>
          </div>
          <ReactApexChart options={chartData3.options} series={chartData3.series} type="line" height={60} width="100%" />
        </div>
        <div className='bg-bg-dark rounded-lg shadow-light'>
          <div className='md:p-20 p-15'>
            <div className='text-[16px]/[20px] font-medium mb-10 flex items-center gap-10'>
              <IconEye className='w-[20px] h-[20px] stroke-[1.5]' />
              View
            </div>
            <div className=''>
              421,215
            </div>
          </div>
          <ReactApexChart options={chartData4.options} series={chartData4.series} type="bar" height={60} width="100%" />
        </div>
      </div>
      <div className='bg-bg-dark rounded-lg shadow-light mb-30'>
        <div className='text-[16px]/[20px] font-medium md:p-20 p-15'>
          Categories Statistics
        </div>
        <div className='grid sm:grid-cols-4 grid-cols-2 gap-15 md:p-20 p-15'>
          <div>
            <p className='text-[20px]/[24px] font-medium mb-5'>2,048</p>
            <p>Total Leads</p>
          </div>
          <div>
            <p className='text-[20px]/[24px] font-medium mb-5'>521</p>
            <p>Connections</p>
          </div>
          <div>
            <p className='text-[20px]/[24px] font-medium mb-5'>73</p>
            <p>Articles</p>
          </div>
          <div>
            <p className='text-[20px]/[24px] font-medium mb-5'>23</p>
            <p>Categories</p>
          </div>
        </div>
        <ReactApexChart options={chartData.options} series={chartData.series} type="line" height={350} />
      </div>
      <div className='grid md:grid-cols-[2fr_1fr] grid-cols-1 gap-30 mb-30'>
        <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
          <div className='flex justify-between gap-15 sm:flex-row flex-col mb-30'>
            <div className='text-[16px]/[20px] font-medium'>
              Visitors Statistics
            </div>
            <div className='flex items-center gap-30 sm:text-right'>
              <div>
                <small>Page Views</small>
                <p className='text-[20px]/[26px] font-medium'>
                  32,211,536
                </p>
              </div>
              <div>
                <small>Site Visitors</small>
                <p className='text-[20px]/[26px] font-medium'>
                  23,516
                </p>
              </div>
            </div>
          </div>
          <div className='grid md:grid-cols-[2fr_1fr] grid-cols-1 items-center gap-30'>
            <div className='sm:h-[300px] h-[150px]'>
              <VectorMap
                map={worldMill}
                backgroundColor='var(--bg-dark)'
                regionStyle={{
                  initial: {
                    fill: "var(--text-secondary)"
                  },
                  hover: {
                    fill: "var(--primary)"
                  },
                }}
                series={{
                  regions: [{
                    attribute: 'fill',
                    values: {
                      'IN': 'var(--danger)',
                      'AU': 'var(--success)',
                      'US': 'var(--sky)',
                      'GB': 'var(--warning)',
                      'SA': 'var(--info)',
                    }
                  }]
                }}
              />
            </div>
            <div>
              <ReactApexChart options={chartData5.options} series={chartData5.series} type="donut" className="max-w-[500px] pb-10 mx-auto" />
            </div>
          </div>
        </div>
        <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
          <div className='text-[16px]/[20px] font-medium mb-30'>
            <p>
              Marketing Campaign
            </p>
            <small className='text-text-secondary'>
              This Month
            </small>
          </div>
          <div className='overflow-auto'>
            <table className='w-full min-w-[549px]'>
              <tbody>
                <tr className='hover:bg-bg-light'>
                  <td className='p-3 border-t border-border'>
                    <IconBrandFacebook className='w-[30px] h-[30px] stroke-[1.5]' />
                  </td>
                  <td className='p-3 border-t border-border'>
                    <p className='text-[16px]/[19.2px] font-medium'>
                      Facebook Ads
                    </p>
                    <p>
                      1.2k Likes, 418 Shares
                    </p>
                  </td>
                  <td className='p-3 border-t border-border'>
                    <p className='text-[16px]/[19.2px] font-medium'>
                      $ 402
                    </p>
                    <p className='text-text-secondary'>
                      Spent
                    </p>
                  </td>
                  <td align='right' className='p-3 border-t border-border'>
                    <p className='text-success inline-flex items-center'>
                      23
                      <IconArrowNarrowUp className='w-[20px] h-[20px]' />
                    </p>
                    <p className='text-text-secondary'>
                      up
                    </p>
                  </td>
                </tr>
                <tr className='hover:bg-bg-light'>
                  <td className='p-3 border-t border-border'>
                    <IconBrandTwitter className='w-[30px] h-[30px] stroke-[1.5]' />
                  </td>
                  <td className='p-3 border-t border-border'>
                    <p className='text-[16px]/[19.2px] font-medium'>
                      Twitter Ads
                    </p>
                    <p>
                      1k Likes, 128 Shares
                    </p>
                  </td>
                  <td className='p-3 border-t border-border'>
                    <p className='text-[16px]/[19.2px] font-medium'>
                      $ 489
                    </p>
                    <p className='text-text-secondary'>
                      Spent
                    </p>
                  </td>
                  <td align='right' className='p-3 border-t border-border'>
                    <p className='text-danger inline-flex items-center'>
                      -9
                      <IconArrowNarrowDown className='w-[20px] h-[20px]' />
                    </p>
                    <p className='text-text-secondary'>
                      down
                    </p>
                  </td>
                </tr>
                <tr className='hover:bg-bg-light'>
                  <td className='p-3 border-t border-border'>
                    <IconBrandInstagram className='w-[30px] h-[30px] stroke-[1.5]' />
                  </td>
                  <td className='p-3 border-t border-border'>
                    <p className='text-[16px]/[19.2px] font-medium'>
                      Instagram Post
                    </p>
                    <p>
                      1k Likes, 228 Shares
                    </p>
                  </td>
                  <td className='p-3 border-t border-border'>
                    <p className='text-[16px]/[19.2px] font-medium'>
                      $ 718
                    </p>
                    <p className='text-text-secondary'>
                      Spent
                    </p>
                  </td>
                  <td align='right' className='p-3 border-t border-border'>
                    <p className='text-success inline-flex items-center'>
                      16
                      <IconArrowNarrowUp className='w-[20px] h-[20px]' />
                    </p>
                    <p className='text-text-secondary'>
                      up
                    </p>
                  </td>
                </tr>
                <tr className='hover:bg-bg-light'>
                  <td className='p-3 border-t border-border'>
                    <IconBrandLinkedin className='w-[30px] h-[30px] stroke-[1.5]' />
                  </td>
                  <td className='p-3 border-t border-border'>
                    <p className='text-[16px]/[19.2px] font-medium'>
                      LinkedIn Post
                    </p>
                    <p>
                      1.2k Likes, 418 Shares
                    </p>
                  </td>
                  <td className='p-3 border-t border-border'>
                    <p className='text-[16px]/[19.2px] font-medium'>
                      $ 768
                    </p>
                    <p className='text-text-secondary'>
                      Spent
                    </p>
                  </td>
                  <td align='right' className='p-3 border-t border-border'>
                    <p className='text-success inline-flex items-center'>
                      27
                      <IconArrowNarrowUp className='w-[20px] h-[20px]' />
                    </p>
                    <p className='text-text-secondary'>
                      up
                    </p>
                  </td>
                </tr>
                <tr className='hover:bg-bg-light'>
                  <td className='p-3 border-t border-border'>
                    <IconBrandGoogle className='w-[30px] h-[30px] stroke-[1.5]' />
                  </td>
                  <td className='p-3 border-t border-border'>
                    <p className='text-[16px]/[19.2px] font-medium'>
                      Google +
                    </p>
                    <p>
                      1.2k Likes, 418 Shares
                    </p>
                  </td>
                  <td className='p-3 border-t border-border'>
                    <p className='text-[16px]/[19.2px] font-medium'>
                      $ 1768
                    </p>
                    <p className='text-text-secondary'>
                      Spent
                    </p>
                  </td>
                  <td align='right' className='p-3 border-t border-border'>
                    <p className='text-success inline-flex items-center'>
                      27
                      <IconArrowNarrowUp className='w-[20px] h-[20px]' />
                    </p>
                    <p className='text-text-secondary'>
                      up
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className='grid xl:grid-cols-4 md:grid-cols-2 xl:gap-30 gap-20'>
        <div className='bg-bg-dark rounded-lg shadow-light'>
          <div className='pb-15 mb-15 border-b border-border text-center md:p-20 p-15'>
            <p className='mb-2 text-[20px]/[26px] font-medium'>
              Twitter
            </p>
            <small>
              56% Increase
            </small>
          </div>
          <ReactApexChart options={chartData6.options} series={chartData6.series} type="radialBar" height={190} className="mx-auto" />
        </div>
        <div className='bg-bg-dark rounded-lg shadow-light'>
          <div className='pb-15 mb-15 border-b border-border text-center md:p-20 p-15'>
            <p className='mb-2 text-[20px]/[26px] font-medium'>
              Facebook
            </p>
            <small>
              87% Increase
            </small>
          </div>
          <ReactApexChart options={chartData7.options} series={chartData7.series} type="radialBar" height={200} className="mx-auto" />
        </div>
        <div className='bg-bg-dark rounded-lg shadow-light'>
          <div className='pb-15 mb-15 border-b border-border text-center md:p-20 p-15'>
            <p className='mb-2 text-[20px]/[26px] font-medium'>
              Instagram
            </p>
            <small>
              16% Increase
            </small>
          </div>
          <ReactApexChart options={chartData8.options} series={chartData8.series} type="radialBar" height={200} className="mx-auto" />
        </div>
        <div className='bg-bg-dark rounded-lg shadow-light'>
          <div className='pb-15 mb-15 border-b border-border text-center md:p-20 p-15'>
            <p className='mb-2 text-[20px]/[26px] font-medium'>
              Google +
            </p>
            <small>
              37% Increase
            </small>
          </div>
          <ReactApexChart options={chartData9.options} series={chartData9.series} type="radialBar" height={200} className="mx-auto" />
        </div>
      </div>
    </>
  )
}
